<template>
  <ul class="figure">
    <li v-for="figure in figures" :key="'figure-' + figure.id">
      <button @click="selectedFigure=figure;show = true;/*selected_figure(selectedFigure)*/">
        <div class="badge">{{figure.design_count}}デザイン</div>
        <div v-html="figure.image_front"></div>
        <div class="label" v-html="figure.name"></div>
      </button>

      <div :show.sync="show" :class="{'uk-modal':true,'uk-open':show}" v-if="selectedFigure === figure">
        <div class="uk-modal-dialog">
          <button class="uk-close uk-icon uk-modal-close-default" @click="show = false">
            <svg width="14" height="14" viewBox="0 0 14 14"><path fill="none" stroke="#000" stroke-width="1.1" d="M1 1l12 12M13 1L1 13"></path></svg>
          </button>
          <div class="uk-modal-body">
            <div class="uk-modal-header">
              <h2>{{ selectedFigure.name | stripTags }}</h2>
              ( {{ figure.design_count }}デザイン )
            </div>
            <div class="uk-modal-body">
              <div v-html="selectedFigure.image_front"></div>
              <div v-html="selectedFigure.comment"></div>
            </div>
            <div class="uk-modal-footer">
              <div v-if="notSameFigure===true" class="warning">
                ※他のアイテム、タイプ、デザインを選択されると、現在編集中のデザインはクリアされますのでご注意ください。
              </div>
              <vk-button class="close" @click="show = false">キャンセル</vk-button>
              <vk-button class="close" @click="save">決定</vk-button>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
  import { mapActions } from 'vuex'
  import axios from 'axios/dist/axios.min'

  export default {
    name: 'product-figure',
    data(){
      return {
        category_id: null,
        figures: [],
        show: true,
        selectedFigure: {
          name:'',
          comment:'',
          image_front:'',
          image_back:'',
        },
      }
    },
    computed: {
      selectedCategory () {
        return this.$store.state.cart.category;
      },
      notSameFigure() {
        if (this.$store.state.cart.figure === null) return null;
        return this.selected_figure.id !== this.$store.state.cart.figure.id;
      }
    },
    methods: {
      ...mapActions([
        'selected_figure',
      ]),
      initialize: function () {
        this.category_id = (this.$route.params.category_id) ? this.$route.params.category_id : this.$store.state.cart.category.id;
        // if (!this.$store.state.cart.category) {
        //   this.$router.push({name: 'category'});
        // }
        this.figures = [];
        this.$store.commit('setLoading');
        axios.get(`/figures.json?category_id=${this.category_id}`).then(response => {
          for (let i = 0; i < response.data.figures.length; i++) {
            this.figures.push(response.data.figures[i]);
          }
          this.$store.commit('resetLoading');
        });
      },
      save: function() {
        this.show = false;
        this.selected_figure(this.selectedFigure);
        if (this.notSameFigure === true) {
          this.$store.commit('clearDesign');
          this.$store.commit('clearLetters');
          this.$store.commit('clearPacks');
          this.$store.commit('disableAfterActiveTab', 1);
          this.$router.push({
            name: 'design',
            params: {category_id: this.category_id, figure_id: this.selectedFigure.id},
          });
        }
      }
    },
    created (){
      this.initialize();
    },
    deactivated(){
      this.$store.commit('resetLoading');
    },
    watch: {
      selectedCategory: function() {
        this.initialize();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .warning {
    text-align: left;
    color: #ee0000;
    font-size: 90%;
    margin-bottom: 1em;
  }
  button{
    height: 100px;
    padding: 0;
    .label{
      position: absolute;
      top: 26px;
      width: 110px;
      text-align: center;
      line-height: 0.9rem;
    }
    .badge {
      border-radius: 0;
      bottom: 0;
      top: auto;
      width: 100%;
      right: auto;
    }
  }
  #product-menu .product_list > ul > li button.close {
    background: #151d66;
    height: auto;
    color: white;
    margin-right: 2px;
  }

  /* アニメーション後に自動でuk-openがついてくれなくなったので仕方なくvk-modalを自分で実装 */
  .uk-modal.uk-open{
    display:block;
  }
  #product-menu .product_list > ul > li button.info {
    width: 20px;
    height: 20px;
    position: absolute;
    background: #151d66;
    color: white;
    top: -2px;
    right: -2px;
    border: 1px solid silver;
  }
  .center{
    text-align: center;
  }
  .uk-modal-body {
    /deep/ img {
      max-width: 100% !important;
    }
  }
</style>
